import * as Sentry from '@sentry/react';
import React, { ErrorInfo } from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  error: Error | null;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  /** @deprecated */
  handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ error: null });
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
    Sentry.captureException(error);
  }

  render() {
    if (this.state.error) {
      return this.props.fallback || <h1>{this.state.error.toString()}</h1>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
